var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledgeBase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chrome Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SideNav-Revised",
    transform: "translate(-29.000000, -983.000000)",
    fill: "#F16334",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 981.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(4.800000, 3.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3,-0.9 L-0.9,-0.9 L-0.9,17.5153846 L15.3,17.5153846 L15.3,-0.9 Z M13.5,0.9 L13.5,15.7152 L0.9,15.7152 L0.9,0.9 L13.5,0.9 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(3.068052, 4.302791)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20",
    points: "6.18478347 -0.346153846 6.18478347 1.45384615 1.25766064e-13 1.45384615 1.25766064e-13 -0.346153846"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20-Copy",
    points: "3.96939886 4.08461538 3.96939886 5.88461538 1.77191595e-13 5.88461538 1.77191595e-13 4.08461538"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBase);
export default __webpack_public_path__ + "static/media/knowledge_base.ca7b5c13f6eaea58f0bb565a578c8c46.svg";
export { ForwardRef as ReactComponent };